"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPlannerRowSchema = void 0;
exports.zonedDateTimeToUtc = zonedDateTimeToUtc;
exports.zonedParts = zonedParts;
const zod_1 = require("zod");
const schemas_1 = require("./schemas");
/** F24.08 "+ Add row": the candidate moves from Contact to Interview 1 and their interview is made (Q1). */
exports.addPlannerRowSchema = zod_1.z.object({
    applicationId: schemas_1.uuidSchema,
    version: zod_1.z.number().int().min(1),
});
// --- Times in a zone ----------------------------------------------------------------------
// The browser has no timezone library (bundle size, CLAUDE.md §4), and the planner needs to
// turn "11:00 on the 14th, Dhaka" into one instant and back. Intl knows every zone's offset.
const MINUTE_MS = 60_000;
const DAY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const TIME_PATTERN = /^(\d{2}):(\d{2})$/;
/** The zone's offset from UTC at an instant, in minutes (Dhaka: +360). */
function offsetMinutes(at, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).formatToParts(at);
    const value = (type) => Number(parts.find((part) => part.type === type)?.value ?? 0);
    const asUtc = Date.UTC(value('year'), value('month') - 1, value('day'), value('hour'), value('minute'), value('second'));
    return Math.round((asUtc - Math.floor(at.getTime() / 1000) * 1000) / MINUTE_MS);
}
/**
 * `YYYY-MM-DD` and `HH:mm` on the wall clock in `timeZone`, as one UTC instant. Two passes
 * settle a day on which the offset changes (DST); a time that doesn't exist that day rolls
 * forward, as a calendar would. Null for a malformed day or time.
 */
function zonedDateTimeToUtc(day, time, timeZone) {
    const dayMatch = DAY_PATTERN.exec(day);
    const timeMatch = TIME_PATTERN.exec(time);
    if (!dayMatch || !timeMatch)
        return null;
    const wallAsUtc = Date.UTC(Number(dayMatch[1]), Number(dayMatch[2]) - 1, Number(dayMatch[3]), Number(timeMatch[1]), Number(timeMatch[2]));
    const first = wallAsUtc - offsetMinutes(new Date(wallAsUtc), timeZone) * MINUTE_MS;
    const second = wallAsUtc - offsetMinutes(new Date(first), timeZone) * MINUTE_MS;
    return new Date(second);
}
/** An instant as the day and time on the wall clock in `timeZone`. */
function zonedParts(iso, timeZone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }).formatToParts(new Date(iso));
    const value = (type) => parts.find((part) => part.type === type)?.value ?? '';
    return { day: `${value('year')}-${value('month')}-${value('day')}`, time: `${value('hour')}:${value('minute')}` };
}
//# sourceMappingURL=planner.js.map